import { CaretRight } from '@phosphor-icons/react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { BC_EXPERIENCE, startExperienceFromChart } from '../../../../utils/birthChartExperience';
import styles from './styles.module.scss';

/** "What you can do with your chart" — shared by both tabs. */
const ChartCtas = ({ variant, onClose, onCtaClose }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const start = (kind) => {
        // Close first so the chat is uncovered before the experience starts.
        // `onCtaClose` lets the host close without the "chart dismissed" side effects
        // (the advisor's follow-up) — the experience starting next is the response.
        if (variant === 'modal') (onCtaClose || onClose)?.();
        startExperienceFromChart(kind, { navigate, pathname });
    };

    return (
        <section className={styles.ctas}>
            <span className={styles.divider} aria-hidden="true" />
            <h3 className={classNames(styles.eyebrow, styles.ctasEyebrow)}>{t('birthChart.view.ctas.title')}</h3>
            <button type="button" className={styles.cta} onClick={() => start(BC_EXPERIENCE.TAROT)}>
                <span>{t('birthChart.view.ctas.tarot')}</span>
                <CaretRight className={styles.ctaCaret} size={20} weight="light" aria-hidden="true" />
            </button>
            <button type="button" className={styles.cta} onClick={() => start(BC_EXPERIENCE.HOROSCOPE)}>
                <span>{t('birthChart.view.ctas.horoscope')}</span>
                <CaretRight className={styles.ctaCaret} size={20} weight="light" aria-hidden="true" />
            </button>
        </section>
    );
};

export default ChartCtas;
